import React from "react";

const VARIANTS = {
    Basso: "bg-[#16A34A]/10 text-[#16A34A] border-[#16A34A]/30",
    Attenzione: "bg-[#F59E0B]/10 text-[#F59E0B] border-[#F59E0B]/30",
    Medio: "bg-[#F59E0B]/20 text-[#B45309] border-[#F59E0B]/40",
    Alto: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30",
    Critico: "bg-[#DC2626] text-white border-[#DC2626]",
};

export function RiskBadge({ level = "Basso", className = "" }) {
    const v = VARIANTS[level] || VARIANTS.Basso;
    return (
        <span
            data-testid={`risk-badge-${String(level).toLowerCase()}`}
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${v} ${className}`}
        >
            {level}
        </span>
    );
}

export default RiskBadge;
